/**
 * A value the product did not write, isolated from the bidi algorithm.
 *
 * `<Figure>` forces left-to-right, which is right for a code, a date or
 * a number and WRONG for a name: an Arabic service name inside an
 * Arabic sentence would be turned round by it.
 *
 * `<bdi>` isolates without imposing a direction -- the browser reads
 * the content's own first strong character. So a latin evidence name
 * inside an Arabic line stays intact, and an Arabic one stays Arabic.
 *
 * Use this for server-supplied names and user-typed text; use
 * `<Figure>` for codes and figures.
 */
export function Bdi({ children }: { children: React.ReactNode }) {
  return <bdi>{children}</bdi>;
}
